import request from '@/api/request'
import api from '@/api/api'
import config from '@/api/config'
export const QueryDoCity = (params) => {
    return request.post(config.uriGateway+api.QueryDoCity, params)
}
//export const QueryDoCity = (params) => {
//  return request.post(api.QueryDoCity, params)
//}
export const GetMeetingTypes = (params) => {
    return request.post(api.GetMeetingTypes, params)
}
export const QueryAddresses = (params) => {
    return request.post(api.QueryAddresses, params)
}
export const QueryTimelist = (params) => {
    return request.post(api.QueryTimelist, params)
}
export const IndexConfig = (params) => {
    return request.post(config.uriGateway+api.IndexConfig, params)
}
//获取外部站点url
export const GetOrderUrl = (params) => { 
    return request.post(config.uriGateway+api.GetOrderUrl, params)
}
export const MeiTuanLogin = (params) => { 
    return request.post(config.uriGateway+api.meiTuanLogin, params)
}
export const getMe = (params) => { 
    return request.post(config.uriGateway+api.getMe, params)
}

export const rest = (params) => {
    return request.get(config.uriGateway+api.rest, { params: params })
}
export const saveCacheData = (params) => {
    return request.post(config.uriGateway+api.saveCacheData, params)
}



// WEBPACK FOOTER //
// ./src/api/common.js